import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import ReceiptHeader from "./components/ReceiptHeader";
import ReceiptTable from "./components/ReceiptTable";

const Receipts = () => {
  const [params] = useSearchParams();

  const verified = params.get("verified")
    ? params.get("verified") === "true"
    : "";

  const [data, setData] = useState([]);

  const [tableOptions, setTableOptions] = useState({
    year: "",
    quarter: "",
    is_verified: verified,
    search_query: "",
    current_page: 1,
    size: 10,
    sort_column: { path: "created_on", order: "desc" },
  });

  const columns = [
    { path: "name", label: "Name" },
    { path: "verified", label: "Verified" },
    { path: "created_on", label: "Date Uploaded" },
  ];

  return (
    <div className="px-6 lg:px-0">
      <div className="card p-8 mt-5">
        <ReceiptHeader options={tableOptions} onChange={setTableOptions} />
        <ReceiptTable
          data={data}
          columns={columns}
          options={tableOptions}
          onChange={setTableOptions}
          setData={setData}
        />
      </div>
    </div>
  );
};

export default Receipts;
